import { Checkbox, Collapse, FormInstance, Input, Row, Typography } from "antd";
import { MceEditor } from "shared/components/tinymce/mce-editor";
import { UploadFileLocal } from "shared/components/upload-file/upload-file";
import { CoreResource, t } from "shared/plugins/localization";
import { cleanUnicode } from "shared/plugins/string-helper";
import { BlogCategoryModel } from "states/blog-category/blog-category.models";

export interface IBlogCategoryInformationTabProps {
  model: BlogCategoryModel;
  onChange: (newModel: BlogCategoryModel) => void;
  isUpdateMode: boolean;
}
export function BlogCategoryInformationTab(
  props: IBlogCategoryInformationTabProps
) {
  const { model, onChange, isUpdateMode } = props;
  return (
    <div>
      <Collapse defaultActiveKey={["1"]} className="mb-4">
        <Collapse.Panel key="1" header="Thông tin">
          <Input.Group className="mb-4">
            <Typography.Text>Tên danh mục: </Typography.Text>
            <Input
              value={model.name}
              onChange={(e) => {
                onChange({
                  ...model,
                  name: e.target.value,
                  slug: cleanUnicode(e.target.value),
                  seoFields: {
                    ...model.seoFields,
                    metaTitle: e.target.value,
                  },
                });
              }}
              placeholder={`Tên danh mục`}
            ></Input>
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Hình đại diện: </Typography.Text>
            <UploadFileLocal
              album={model.avatar ? [model.avatar] : []}
              maxFileCount={1}
              multiple={false}
              onChange={(newFileList: string[]) => {
                onChange({
                  ...model,
                  avatar: newFileList[0],
                });
              }}
            />
          </Input.Group>
          <Input.Group className="mb-4">
            <Typography.Text>Mô tả: </Typography.Text>
            <MceEditor
              pageContent={model.description}
              onChange={(value) => {
                onChange({ ...model, description: value });
              }}
            ></MceEditor>
          </Input.Group>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
